export class UnifiedEventsSdk {
    reportAccountDeletionRegistered(options = {}) {
        this._processEventReport('AccountDeletionRegisteredEvent', {}, options);
    }
    reportAccountDeletionRequestFailed(event, options = {}) {
        this._processEventReport('AccountDeletionRequestFailedEvent', event, options);
    }
    reportAccountDeletionRequested(options = {}) {
        this._processEventReport('AccountDeletionRequestedEvent', {}, options);
    }
    reportAdsBiddingRequestFailed(event, options = {}) {
        this._processEventReport('AdsBiddingRequestFailedEvent', event, options);
    }
    reportAdsBiddingRequested(event, options = {}) {
        this._processEventReport('AdsBiddingRequestedEvent', event, options);
    }
    reportAdsBiddingResponseReceived(event, options = {}) {
        this._processEventReport('AdsBiddingResponseReceivedEvent', event, options);
    }
    reportAdsDisplayCertifiedImpression(event, options = {}) {
        this._processEventReport('AdsDisplayCertifiedImpressionEvent', event, options);
    }
    reportAdsDisplayClicked(event, options = {}) {
        this._processEventReport('AdsDisplayClickedEvent', event, options);
    }
    reportAdsDisplayClosed(event, options = {}) {
        this._processEventReport('AdsDisplayClosedEvent', event, options);
    }
    reportAdsDisplayImpression(event, options = {}) {
        this._processEventReport('AdsDisplayImpressionEvent', event, options);
    }
    reportAdsDisplayRequestCancelled(event, options = {}) {
        this._processEventReport('AdsDisplayRequestCancelledEvent', event, options);
    }
    reportAdsDisplayRequestFailed(event, options = {}) {
        this._processEventReport('AdsDisplayRequestFailedEvent', event, options);
    }
    reportAdsDisplayRequested(event, options = {}) {
        this._processEventReport('AdsDisplayRequestedEvent', event, options);
    }
    reportAdsDisplayResponseReceived(event, options = {}) {
        this._processEventReport('AdsDisplayResponseReceivedEvent', event, options);
    }
    reportAdsDisplayViewabilityStatus(event, options = {}) {
        this._processEventReport('AdsDisplayViewabilityStatusEvent', event, options);
    }
    reportAdsInstreamCompleted(event, options = {}) {
        this._processEventReport('AdsInstreamCompletedEvent', event, options);
    }
    reportAdsInstreamQuartileStatus(event, options = {}) {
        this._processEventReport('AdsInstreamQuartileStatusEvent', event, options);
    }
    reportAdsInstreamReceived(event, options = {}) {
        this._processEventReport('AdsInstreamReceivedEvent', event, options);
    }
    reportAdsInstreamStarted(event, options = {}) {
        this._processEventReport('AdsInstreamStartedEvent', event, options);
    }
    reportAdsPlaybackCancelled(event, options = {}) {
        this._processEventReport('AdsPlaybackCancelledEvent', event, options);
    }
    reportAdsPlaybackFailed(event, options = {}) {
        this._processEventReport('AdsPlaybackFailedEvent', event, options);
    }
    reportAdsPlaybackFinished(event, options = {}) {
        this._processEventReport('AdsPlaybackFinishedEvent', event, options);
    }
    reportAdsPlaybackPaused(event, options = {}) {
        this._processEventReport('AdsPlaybackPausedEvent', event, options);
    }
    reportAdsPlaybackResumed(event, options = {}) {
        this._processEventReport('AdsPlaybackResumedEvent', event, options);
    }
    reportAdsPlaybackStarted(event, options = {}) {
        this._processEventReport('AdsPlaybackStartedEvent', event, options);
    }
    reportAdsVideoAudioRollClicked(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollClickedEvent', event, options);
    }
    reportAdsVideoAudioRollCompleted(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollCompletedEvent', event, options);
    }
    reportAdsVideoAudioRollEligibilityDecided(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollEligibilityDecidedEvent', event, options);
    }
    reportAdsVideoAudioRollRequestFailed(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollRequestFailedEvent', event, options);
    }
    reportAdsVideoAudioRollRequested(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollRequestedEvent', event, options);
    }
    reportAdsVideoAudioRollResponseReceived(event, options = {}) {
        this._processEventReport('AdsVideoAudioRollResponseReceivedEvent', event, options);
    }
    reportAppAccessTokenRefreshFailed(event, options = {}) {
        this._processEventReport('AppAccessTokenRefreshFailedEvent', event, options);
    }
    reportApplicationSessionStarted(options = {}) {
        this._processEventReport('ApplicationSessionStartedEvent', {}, options);
    }
    reportAutoAccountLinked(options = {}) {
        this._processEventReport('AutoAccountLinkedEvent', {}, options);
    }
    reportAutoAppFirstOpen(options = {}) {
        this._processEventReport('AutoAppFirstOpenEvent', {}, options);
    }
    reportAutoAppInitiated(options = {}) {
        this._processEventReport('AutoAppInitiatedEvent', {}, options);
    }
    reportAutoContentRequestFailed(event, options = {}) {
        this._processEventReport('AutoContentRequestFailedEvent', event, options);
    }
    reportAutoEmptyPageReturned(event, options = {}) {
        this._processEventReport('AutoEmptyPageReturnedEvent', event, options);
    }
    reportAutoHomePageLoaded(options = {}) {
        this._processEventReport('AutoHomePageLoadedEvent', {}, options);
    }
    reportAutoLocationConsentShown(options = {}) {
        this._processEventReport('AutoLocationConsentShownEvent', {}, options);
    }
    reportAutoLocationConsentSkipped(options = {}) {
        this._processEventReport('AutoLocationConsentSkippedEvent', {}, options);
    }
    reportAutoLocationPermissionDenied(options = {}) {
        this._processEventReport('AutoLocationPermissionDeniedEvent', {}, options);
    }
    reportAutoLocationPermissionGranted(options = {}) {
        this._processEventReport('AutoLocationPermissionGrantedEvent', {}, options);
    }
    reportAutoRegistrationDataRequestFailed(event, options = {}) {
        this._processEventReport('AutoRegistrationDataRequestFailedEvent', event, options);
    }
    reportAutoRegistrationPinCodeShown(options = {}) {
        this._processEventReport('AutoRegistrationPinCodeShownEvent', {}, options);
    }
    reportAutoRegistrationSessionExpired(event, options = {}) {
        this._processEventReport('AutoRegistrationSessionExpiredEvent', event, options);
    }
    reportAutoRegistrationShown(options = {}) {
        this._processEventReport('AutoRegistrationShownEvent', {}, options);
    }
    reportAutoSubscriptionDataRequestFailed(event, options = {}) {
        this._processEventReport('AutoSubscriptionDataRequestFailedEvent', event, options);
    }
    reportAutoUiCategoryFailed(event, options = {}) {
        this._processEventReport('AutoUiCategoryFailedEvent', event, options);
    }
    reportAutoUiCategoryLoaded(event, options = {}) {
        this._processEventReport('AutoUiCategoryLoadedEvent', event, options);
    }
    reportAutoUiRootFailed(event, options = {}) {
        this._processEventReport('AutoUiRootFailedEvent', event, options);
    }
    reportAutoUiRootLoaded(options = {}) {
        this._processEventReport('AutoUiRootLoadedEvent', {}, options);
    }
    reportAutoUiSearchResultFailed(event, options = {}) {
        this._processEventReport('AutoUiSearchResultFailedEvent', event, options);
    }
    reportAutoUiSearchResultLoaded(options = {}) {
        this._processEventReport('AutoUiSearchResultLoadedEvent', {}, options);
    }
    reportAutoUiServiceConnected(options = {}) {
        this._processEventReport('AutoUiServiceConnectedEvent', {}, options);
    }
    reportAutoUiServiceConnectionFailed(options = {}) {
        this._processEventReport('AutoUiServiceConnectionFailedEvent', {}, options);
    }
    reportAutoUiServiceConnectionSuspended(options = {}) {
        this._processEventReport('AutoUiServiceConnectionSuspendedEvent', {}, options);
    }
    reportAutoUiSessionDestroyed(options = {}) {
        this._processEventReport('AutoUiSessionDestroyedEvent', {}, options);
    }
    reportContentClicked(event, options = {}) {
        this._processEventReport('ContentClickedEvent', event, options);
    }
    reportContentImpression(event, options = {}) {
        this._processEventReport('ContentImpressionEvent', event, options);
    }
    reportDiscordActivityEnded(event, options = {}) {
        this._processEventReport('DiscordActivityEndedEvent', event, options);
    }
    reportDiscordActivityInitiated(event, options = {}) {
        this._processEventReport('DiscordActivityInitiatedEvent', event, options);
    }
    reportDiscordHostAssigned(event, options = {}) {
        this._processEventReport('DiscordHostAssignedEvent', event, options);
    }
    reportDiscordMaxParticipantsReached(event, options = {}) {
        this._processEventReport('DiscordMaxParticipantsReachedEvent', event, options);
    }
    reportDiscordOauthAccepted(event, options = {}) {
        this._processEventReport('DiscordOauthAcceptedEvent', event, options);
    }
    reportDiscordOauthDenied(event, options = {}) {
        this._processEventReport('DiscordOauthDeniedEvent', event, options);
    }
    reportDiscordSharedModeActivated(event, options = {}) {
        this._processEventReport('DiscordSharedModeActivatedEvent', event, options);
    }
    reportDiscordSharedModeDeactivated(event, options = {}) {
        this._processEventReport('DiscordSharedModeDeactivatedEvent', event, options);
    }
    reportDiscordUserJoined(event, options = {}) {
        this._processEventReport('DiscordUserJoinedEvent', event, options);
    }
    reportDiscordUserLeft(event, options = {}) {
        this._processEventReport('DiscordUserLeftEvent', event, options);
    }
    reportListenSessionStarted(event, options = {}) {
        this._processEventReport('ListenSessionStartedEvent', event, options);
    }
    reportPrebufferConnectionLostPlaybackContinues(event, options = {}) {
        this._processEventReport('PrebufferConnectionLostPlaybackContinuesEvent', event, options);
    }
    reportPrebufferPrerollCancelled(event, options = {}) {
        this._processEventReport('PrebufferPrerollCancelledEvent', event, options);
    }
    reportPrebufferPrerollEligibilityDecided(event, options = {}) {
        this._processEventReport('PrebufferPrerollEligibilityDecidedEvent', event, options);
    }
    reportPrebufferPrerollFailed(event, options = {}) {
        this._processEventReport('PrebufferPrerollFailedEvent', event, options);
    }
    reportPrebufferPrerollRequestFailed(event, options = {}) {
        this._processEventReport('PrebufferPrerollRequestFailedEvent', event, options);
    }
    reportPrebufferPrerollRequested(event, options = {}) {
        this._processEventReport('PrebufferPrerollRequestedEvent', event, options);
    }
    reportPrebufferPrerollResponseReceived(event, options = {}) {
        this._processEventReport('PrebufferPrerollResponseReceivedEvent', event, options);
    }
    reportPrebufferPrerollStarted(event, options = {}) {
        this._processEventReport('PrebufferPrerollStartedEvent', event, options);
    }
    reportPrebufferPrerollSuccess(event, options = {}) {
        this._processEventReport('PrebufferPrerollSuccessEvent', event, options);
    }
    reportPrebufferPrerollTimeout(event, options = {}) {
        this._processEventReport('PrebufferPrerollTimeoutEvent', event, options);
    }
    reportPrebufferStreamCancelled(event, options = {}) {
        this._processEventReport('PrebufferStreamCancelledEvent', event, options);
    }
    reportPrebufferStreamEligibilityDecided(event, options = {}) {
        this._processEventReport('PrebufferStreamEligibilityDecidedEvent', event, options);
    }
    reportPrebufferStreamFailed(event, options = {}) {
        this._processEventReport('PrebufferStreamFailedEvent', event, options);
    }
    reportPrebufferStreamStarted(event, options = {}) {
        this._processEventReport('PrebufferStreamStartedEvent', event, options);
    }
    reportPrebufferStreamSuccess(event, options = {}) {
        this._processEventReport('PrebufferStreamSuccessEvent', event, options);
    }
    reportPrebufferStreamTimeout(event, options = {}) {
        this._processEventReport('PrebufferStreamTimeoutEvent', event, options);
    }
    reportPrebufferTimeEnded(options = {}) {
        this._processEventReport('PrebufferTimeEndedEvent', {}, options);
    }
    reportPrebufferUserFastForwarded(options = {}) {
        this._processEventReport('PrebufferUserFastForwardedEvent', {}, options);
    }
    reportPrebufferUserRewound(options = {}) {
        this._processEventReport('PrebufferUserRewoundEvent', {}, options);
    }
    reportPrebufferUserWentLive(options = {}) {
        this._processEventReport('PrebufferUserWentLiveEvent', {}, options);
    }
    reportSandbox(event, options = {}) {
        this._processEventReport('SandboxEvent', event, options);
    }
    reportUpdateAvailable(options = {}) {
        this._processEventReport('UpdateAvailableEvent', {}, options);
    }
    reportUpdateDownloadFailed(event, options = {}) {
        this._processEventReport('UpdateDownloadFailedEvent', event, options);
    }
    reportUpdateDownloadStarted(options = {}) {
        this._processEventReport('UpdateDownloadStartedEvent', {}, options);
    }
    reportUpdateDownloadSuccess(options = {}) {
        this._processEventReport('UpdateDownloadSuccessEvent', {}, options);
    }
    reportUpdateInstallationStarted(options = {}) {
        this._processEventReport('UpdateInstallationStartedEvent', {}, options);
    }
    reportUserPlayClicked(event, options = {}) {
        this._processEventReport('UserPlayClickedEvent', event, options);
    }
}
